import { PASSWORD_REGEX } from "@talkouttech/portal-shared";
import * as yup from "yup";

export const passwordValidation = yup
  .string()
  .required("errors.required")
  .min(8, "errors.atLeast8Chars")
  .matches(PASSWORD_REGEX, "errors.passwordChars");
